import { Col, Row, Space } from "antd";
import { useDashboardOrganizationSatesQuery } from "../../../../features/superAdmin/dashboard/dashboardApi";
import { addCommaInNumber } from "../../../../utils/number";
import { DFilters } from "../Dashboard";
import ApprovedTicketIcon from "../_icons/ApprovedTicketIcon";
import CanceledTicketIcon from "../_icons/CanceledTicketIcon";
import CheckedTicketIcon from "../_icons/CheckedTicketIcon";
import ClosedTicketIcon from "../_icons/ClosedTicketIcon";
import ExecutedTicketIcon from "../_icons/ExecutedTicketIcon";
import InProgressTicketIcon from "../_icons/InProgressTicketIcon";
import OpenedTicketIcon from "../_icons/OpenedTicketIcon";
import OrganizationTicketIcon from "../_icons/OrganizationTicketIcon";
import RejectedTicketIcon from "../_icons/RejectedTicketIcon";
import ResolvedTicketIcon from "../_icons/ResolvedTicketIcon";
import SLABreachedTicketIcon from "../_icons/SLABreachedTicketIcon";
import TotalTicketIcon from "../_icons/TotalTicketIcon";
import WaitingForApprovalIcon from "../_icons/WaitingForApprovalIcon";
import WithLoader from "./WithLoader";

type Config = {
  icon: React.JSX.Element;
  wrapperClass?: string;
  title: string;
  content: number | string;
};

const OrganizationStates = ({
  toDate,
  fromDate,
  skip,
  limit,
  ...filter
}: DFilters) => {
  const { data, isLoading, isFetching } = useDashboardOrganizationSatesQuery({
    params: {
      ...filter,
      fromDate: fromDate ? fromDate : undefined,
      toDate: toDate ? toDate : undefined,
    },
  });

  const {
    totalTickets,
    checkedTickets,
    approvedTickets,
    executedTickets,
    rejectedTickets,
    resolvedTickets,
    // completedTickets,
    cancledTickets,
    waitingForApproval,
    closedTickets,
    openedTickets,
    slaBreachedCount,
    inProgressTickets,
  } = data?.data || {};

  const roleBasedConfig: Config[] = [
    {
      icon: <OrganizationTicketIcon />,
      wrapperClass: "bg-[#F3FAFF]",
      title: "Organization-wide Tickets",
      content: addCommaInNumber(totalTickets || 0),
    },
    {
      icon: <SLABreachedTicketIcon />,
      wrapperClass: "bg-[#FFF5F4]",
      title: "SLA Breached Tickets",
      content: addCommaInNumber(slaBreachedCount || 0), //Todo: Need to provide real data
    },
    {
      icon: <ClosedTicketIcon />,
      wrapperClass: "bg-[#E8FDF9]",
      title: "Tickets Closed",
      content: addCommaInNumber(closedTickets || 0),
    },
    {
      icon: <WaitingForApprovalIcon />,
      wrapperClass: "bg-[#FFFBEB]",
      title: "Waiting for Approval",
      content: addCommaInNumber(waitingForApproval || 0), //Todo: Need to provide real data
    },
  ];

  const config: Config[] = [
    {
      icon: <TotalTicketIcon />,
      title: "Total Tickets",
      content: addCommaInNumber(totalTickets || 0),
    },
    {
      icon: <OpenedTicketIcon />,
      title: "Opened Tickets",
      content: addCommaInNumber(openedTickets || 0),
    },
    {
      icon: <InProgressTicketIcon />,
      title: "In Progress Tickets",
      content: addCommaInNumber(inProgressTickets || 0), //Todo: Need to provide real data
    },
    {
      icon: <ResolvedTicketIcon />,
      title: "Resolved Tickets",
      content: addCommaInNumber(resolvedTickets || 0),
    },
    {
      icon: <CheckedTicketIcon />,
      title: "Checked Tickets",
      content: addCommaInNumber(checkedTickets || 0),
    },
    {
      icon: <ApprovedTicketIcon />,
      title: "Approved Tickets",
      content: addCommaInNumber(approvedTickets || 0),
    },
    {
      icon: <ExecutedTicketIcon />,
      title: "Executed Tickets",
      content: addCommaInNumber(executedTickets || 0),
    },
    {
      icon: <RejectedTicketIcon />,
      title: "Rejected Tickets",
      content: addCommaInNumber(rejectedTickets || 0),
    },
    {
      icon: <CanceledTicketIcon />,
      title: "Canceled Tickets",
      content: addCommaInNumber(cancledTickets || 0),
    },
  ];

  return (
    <WithLoader isLoading={isLoading || isFetching}>
      <Row gutter={[24, 24]}>
        {roleBasedConfig?.map((item) => (
          <Col key={item.title} span={6}>
            <State item={item} key={item.title} />
          </Col>
        ))}
        {config?.map((item) => (
          <Col key={item.title} span={6}>
            <State item={item} key={item.title} />
          </Col>
        ))}
      </Row>
    </WithLoader>
  );
};

const State = ({ item }: { item: Config }) => {
  return (
    <div
      className={`border-none shadow p-4 rounded-lg space-y-2 ${
        item.wrapperClass ? item.wrapperClass : "bg-white"
      }`}
    >
      <Space>
        {item.icon}
        <h6 className="text-base font-normal text-display-body">
          {item.title}
        </h6>
      </Space>
      <h4 className="text-[28px] text-display-body font-normal">
        {item.content}
      </h4>
    </div>
  );
};

export default OrganizationStates;
